// src/utils/errorMapping.js

/**
 * サーバーから受け取ったエラーキーを、クライアントのi18nキーにマッピングします。
 */
const serverToClientErrorKeyMap = {
  // Auth Errors
  'ERROR_EMAIL_PASSWORD_REQUIRED': 'errors.auth.emailPasswordRequired',
  'ERROR_EMAIL_IN_USE': 'errors.auth.emailInUse',
  'ERROR_SIGNUP_FAILED': 'errors.auth.signupFailed',
  'ERROR_INVALID_CREDENTIALS': 'errors.auth.invalidCredentials',
  'ERROR_USER_NOT_FOUND_OR_CORRUPT': 'errors.auth.userNotFoundOrCorrupt',

  // Tournament Errors
  'ERROR_INVALID_TOURNAMENT_ID': 'errors.tournament.invalidId',
  'ERROR_TOURNAMENT_NOT_FOUND': 'errors.tournament.notFound',
  'ERROR_TOURNAMENT_NOT_FOUND_GENERIC': 'errors.tournament.notFoundGeneric',
  'ERROR_NANOID_EXISTS': 'errors.tournament.creationIdConflict',
  'ERROR_TOURNAMENT_CREATION_LIMIT_REACHED': 'errors.tournament.creationLimitReached',
  'ERROR_TOURNAMENT_DELETE_FAILED': 'errors.tournament.deleteFailed',

  // Structure Errors
  'ERROR_INVALID_STRUCTURE_FORMAT': 'errors.structure.invalidFormat',
  'ERROR_STRUCTURE_MISSING': 'errors.structure.missing',
  'ERROR_LEVELS_MISSING': 'errors.structure.levelsMissing',
  'ERROR_NO_LEVELS_DEFINED': 'errors.structure.noLevelsDefined',

  // Admin Action Errors
  'ERROR_FETCH_TOURNAMENTS': 'errors.admin.fetchTournaments',
  'ERROR_FETCH_USERS': 'errors.admin.fetchUsers',
  'ERROR_CANNOT_DELETE_USER_OWNS_TOURNAMENTS': 'errors.admin.userDeletePrecondition',
  'ERROR_INVALID_TIER': 'errors.admin.invalidTier',
  'ERROR_USER_NOT_FOUND': 'errors.admin.userNotFound',
  'ERROR_USER_UPDATE_FAILED': 'errors.admin.userUpdateFailed',
  'ERROR_USER_DELETE_FAILED': 'errors.admin.userDeleteFailed',
  'ERROR_TARGET_USER_ID_REQUIRED': 'errors.admin.targetUserIdRequired',       
  'ERROR_USER_ID_AND_TIER_REQUIRED': 'errors.admin.userIdAndTierRequired', 
};

/**
 * サーバーのエラーキーをクライアントの翻訳キーに変換します。
 * マッピングが存在しない場合は、汎用的なエラーキーを返します。
 * @param {string} serverKey - サーバーから受け取ったエラーキー
 * @returns {string} - クライアント用の翻訳キー
 */
export const mapErrorKey = (serverKey) => {
  return serverToClientErrorKeyMap[serverKey] || 'errors.unknown';
};